<template>
	<div class="omapi-notifications-list">
		<common-transition-slide
			id="om-notification-alerts"
			:active="hasAlerts"
		>
			<core-alerts :alerts="alerts"></core-alerts>
		</common-transition-slide>
		<transition-group name="swipe-right" tag="ul" class="omapi-detailed-list">
			<li
				:key="`${keyPrefix}om-circle-loading`"
				v-if="isLoading"
				class="om-circle-loading"
			/>
			<notifications-single
				v-show="!dismissingAll"
				v-for="notification in notificationsToShow"
				:key="getKey(notification, keyPrefix)"
				:notification="notification"
				ref="notifications"
				@remove="emitRemove"
				@clicked="emitClicked"
			/>
			<li
				v-if="inDrawer"
				key="dismiss-all-notices"
				class="dismiss-all-notices"
			>
				<a href="#" @click.prevent="dismissAll">
					{{ hasNotifications ? 'Dismiss All' : 'Close' }}
				</a>
			</li>
		</transition-group>
	</div>
</template>

<script lang="js">
import { notifications } from '@/notifications/mixins/notifications'

export default  {
	mixins : [ notifications ],
	props  : {
		notificationsToShow : {
			type : Array,
			default () {
				return []
			},
		},
		keyPrefix : {
			type    : String,
			default : '',
		},
		inDrawer : Boolean,
	},
	methods : {
		emitRemove (notificationId) {
			this.$emit('remove', notificationId)
		},
		emitClicked (event) {
			this.$emit('clicked', event)
		},
	},
}
</script>

<style lang="scss">
@import '../../assets/scss/variables';
.omapi-notifications-list {
	.alerts {
		padding-bottom: 5px;
		margin-bottom: 25px;
		border-bottom: solid 1px $color_grey-separator;
	}
	.om-circle-loading {
		margin: 10px auto;
		height: 44px;
		background-size: 44px;
		background-position: top center;
		&.notifications-slide-enter, &.notifications-slide-leave-to {
			opacity: 0;
			height: 0;
			overflow: hidden;
			padding: 0;
			margin: 0;
			border: 0;
		}
	}

	.swipe-right-enter-active, .swipe-right-leave-active {
		transition: all .5s ease-in-out;
	}

	.swipe-right-leave-to {
		transform: translateX(110%);
	}

	.omapi-detailed-list {
		li .omapi-multi-column__secondary {
			font-size: 11px;
			flex: 0 0 85px;
			margin-left: 10px;
		}
		> .dismiss-all-notices {
			justify-content: flex-end;
			border-bottom: 0;
		}
	}
}

.omapi-screen .omapi-notifications-list {
	.omapi-detailed-list > .notifications-loading {
		display: block;
		margin-bottom: 20px;
	}
}
</style>
